import { OBJECTIVE_ATTRIBUTE_TYPE } from "src/consts/objectives";

const getObjectiveTypeBadge = (objective) => {
  if (objective?.objectiveTypeDisplayName) {
    return {
      id: OBJECTIVE_ATTRIBUTE_TYPE.TYPE,
      label: objective.objectiveTypeDisplayName,
    };
  }

  const attributes = objective?.attributes;
  if (!attributes?.length) {
    return null;
  }

  const typeAttr = attributes?.find(
    (attr) => attr.attributeType === OBJECTIVE_ATTRIBUTE_TYPE.TYPE
  );

  if (!typeAttr?.value) {
    return null;
  }

  return {
    id: OBJECTIVE_ATTRIBUTE_TYPE.TYPE,
    label: typeAttr.value,
  };
};

export default getObjectiveTypeBadge;
